// Header.js
import React, { useState, useRef, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faGear, 
  faUser, 
  faPalette, 
  faGlobe, 
  faShieldHalved,
  faRightFromBracket,
  faHistory
} from '@fortawesome/free-solid-svg-icons';
import { useAuth0 } from '@auth0/auth0-react';

import './Header.css';

function Header({ onLogout }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const settingsRef = useRef(null);
  const { isAuthenticated, loginWithRedirect, logout, user, isLoading } = useAuth0();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleSettingsClick = () => {
    setShowSettings(!showSettings);
  };

  // Close settings when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (settingsRef.current && !settingsRef.current.contains(event.target)) {
        setShowSettings(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      loginWithRedirect({
        acr_values: "http://schemas.openid.net/pape/policies/2007/06/multi-factor"
      });
    }
  }, [isLoading, isAuthenticated, loginWithRedirect]);

  const updateWelcomeText = () => {
    if (!user || !user.name) return '';
    
    const name = user.name;
    return `Welcome, ${name.replace(/@.*$/, '')}!`;
  };

  return (
    <header className="wrapper bg-light container">
      <nav className="navbar navbar-expand-lg classic transparent navbar-light">
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="navbar-brand logo-container">
            <NavLink className="nav-link" to="/">
              <img src="/assets/img/irish-logo.png" alt="Irish Funds Logo" />
            </NavLink>
          </div>
          <div className="header-controls d-flex align-items-center gap-3">
            {isAuthenticated && user && (
              <>
                {/* <NavLink 
                  to="/activity-log" 
                  className="activity-log-link"
                >
                  <FontAwesomeIcon icon={faHistory} />
                  <span>Activity Log</span>
                </NavLink> */}

                <div className="user-info">
                  <div className="user-avatar">
                    {user.picture ? (
                      <img src={user.picture} alt={user.name} />
                    ) : (
                      <FontAwesomeIcon icon={faUser} />
                    )}
                  </div>
                  <div className="user-details">
                    <span className="user-name">{user.name}</span>
                    <span className="user-role">Administrator</span>
                  </div>
                </div>

                <div className="admin-controls">
                  <button 
                    onClick={onLogout}
                    className="logout-button"
                  >
                    <FontAwesomeIcon icon={faRightFromBracket} />
                    <span>Logout</span>
                  </button>
                </div>
              </>
            )}
          </div>
        </div>       
      </nav>
    </header>
  );
}

export default Header;
